var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table-pagination",
    {
      attrs: { limit: _vm.limit, offset: _vm.offset, total: _vm.emailCount },
      on: { "page-change": _vm.handlePageChange },
    },
    [
      _c("v-client-table", {
        ref: "clientTable",
        staticClass: "table-clients vue-custom-table w-100 overflow-auto",
        attrs: { data: _vm.list, columns: _vm.columns, options: _vm.options },
        scopedSlots: _vm._u([
          {
            key: "email",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  { staticClass: "d-flex flex-row p-2 align-items-center" },
                  [
                    _c("img", {
                      staticClass: "img-fluid rounded-circle lg",
                      attrs: {
                        src: require("@Shared/@Assets/img/user-male-placeholder.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "h4",
                      { staticClass: "regular text-gray bold ml-3 mb-0" },
                      [
                        _vm._v(
                          "\n          " + _vm._s(row.email) + "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "source",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", { staticClass: "text-capitalize" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getSourceText(row.source)) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "firstname",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.givenName) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "lastname",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.familyName) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "appstatus",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", { staticClass: "text-capitalize" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.getTranslatedApplicationStatus(
                          row.applicationStatus
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "profilestatus",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    "\n        " + _vm._s(row.clientProfileStatus) + "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "value",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formatMoneyValue(row.clientProfileValue)) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "renewaldate",
            fn: function (ref) {
              var row = ref.row
              return [
                row.mortgageRenewalDate
                  ? _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("momentLocal")(
                              row.mortgageRenewalDate,
                              "MMM DD, YYYY"
                            )
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "referrer",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    _vm._s(row.referrer.givenName) +
                      " " +
                      _vm._s(row.referrer.familyName)
                  ),
                ]),
              ]
            },
          },
          {
            key: "phoneNumber",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.phoneNumber) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "coApps",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("show-more", {
                  attrs: {
                    text: _vm.coApplicantsText(row.coApplicants),
                    limit: 20,
                  },
                }),
              ]
            },
          },
          {
            key: "referrerType",
            fn: function (ref) {
              var row = ref.row
              return [
                row.referrerType
                  ? _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("referrers.referrerType." + row.referrerType)
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "referrerCombinedValue",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatMoneyValue")(_vm.getCombined(row))) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "numberOfClients",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    "\n        " + _vm._s(row.numberOfClients) + "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "optin",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("segment-subscribed-button", {
                  attrs: {
                    subscribed: row.subscribed,
                    suppressed: row.suppressed,
                    source: row.source,
                    "email-id": row.emailId,
                    "list-id": _vm.listId,
                    "current-tab": _vm.currentTab,
                  },
                  on: { subscribe: _vm.handleSubscribe },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }